import { render, staticRenderFns } from "./FilialDashboardVendas.vue?vue&type=template&id=3690b20a&scoped=true"
import script from "./FilialDashboardVendas.vue?vue&type=script&lang=js"
export * from "./FilialDashboardVendas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3690b20a",
  null
  
)

export default component.exports